import type { Webhook } from '../types';
import {
  type GoogleSheetsSettings,
  googleSheetsSettings
} from './googleSheetsSettings';
import { type MailchimpSettings, mailchimpSettings } from './mailchimpSettings';
import { type ZapierSettings, zapierSettings } from './zapierSettings';

export const integrationsSettings = {
  ...googleSheetsSettings,
  ...mailchimpSettings,
  ...zapierSettings,
  webhooks: []
};

export type IntegrationsSettings = GoogleSheetsSettings &
  MailchimpSettings &
  ZapierSettings & {
    webhooks: Webhook[];
  };
